import { render } from "./MenuMobileItem.vue?vue&type=template&id=44255f56&scoped=true"
import script from "./MenuMobileItem.vue?vue&type=script&lang=js"
export * from "./MenuMobileItem.vue?vue&type=script&lang=js"

import "./MenuMobileItem.vue?vue&type=style&index=0&id=44255f56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44255f56"]])

export default __exports__